(function () {
  'use strict';

  class ModalRequisicaoVideoCtrl {
    constructor(
      AlertasEnum,
      moment,
      Restangular,
      AlertMessage,
      $translate,
      ServiceVfiltro,
      GoogleTagManagerUtils,
      Authenticator,
      MeasurementUnitConverterService,
      FeatureHubConfigKeys,
      FeaturehubJsSdk
    ) {
      this.alertasEnum = AlertasEnum;
      this.moment = moment;
      this.restangular = Restangular;
      this.alertMessage = AlertMessage;
      this.translate = $translate;
      this.serviceVfiltro = ServiceVfiltro;
      this.googleTagManagerUtils = GoogleTagManagerUtils;
      this.measurementUnitConverterService = MeasurementUnitConverterService;
      this.authenticator = Authenticator;
      this.featureHubConfigKeys = FeatureHubConfigKeys;
      this.featurehubJsSdk = FeaturehubJsSdk;

      this.authenticator.getUser().then(user => {
        this.dateTimeFormat = this.measurementUnitConverterService.getDateFormat(user.measurementUnits.dateTimeFormat);
      });
    }

    $onInit() {
      this.alerta = this.resolve.alerta;
      this.isSnapshotRequest = !!this.resolve.isSnapshotRequest;
      this.tipoAlerta = this.alertasEnum.getAlerta(this.alerta.tipo);
      this.inicioVideo = this.moment(this.alerta.datahora).subtract(5, 'seconds').toISOString();
      this.fimVideo = this.moment(this.alerta.datahora).add(10, 'seconds').toISOString();
      this.snapshotCameras = [];
      this.buildSnapshotCameras();

      if (this.featurehubJsSdk.isFeatureEnabled(this.featureHubConfigKeys.ENABLE_6_CAMERAS)) {
        this.cameras = ['CAMERA_1', 'CAMERA_2', 'CAMERA_3', 'CAMERA_4', 'CAMERA_5', 'CAMERA_6'];
      } else {
        this.cameras = ['CAMERA_1', 'CAMERA_2', 'CAMERA_3', 'CAMERA_4', 'CAMERA_5'];
      }
    }

    getIconBackgroundColor() {
      return `bg-${this.tipoAlerta.cor}`;
    }

    qualificaAlerta(tipoAlerta, nivel) {
      if (nivel) {
        return `${tipoAlerta}_${nivel}`;
      }
      return tipoAlerta;
    }

    request() {
      if (this.isSnapshotRequest) {
        this.requestSnapshot();
      } else {
        this.requisitarVideo();
      }
    }

    requisitarVideo() {
      this.sendEventToGTM();
      this.restangular.all('video/videos')
        .withHttpConfig({transformResponse: angular.identity})
        .post({
          idVeiculo: this.alerta.veiculo.id,
          inicioVideo: this.inicioVideo,
          fimVideo: this.fimVideo,
          descricao: this.translate.instant(this.tipoAlerta.descricao),
          dataHoraEvento: this.alerta.datahora,
          tipoEvento: this.qualificaAlerta(this.tipoAlerta.id, this.alerta.nivel),
          cameras: this.cameras
        })
        .then((videoId) => {
          if (this.resolve.onRequestCompleted && angular.isFunction(this.resolve.onRequestCompleted)) {
            this.resolve.onRequestCompleted();
          }
          this.close({$value: videoId});
        })
        .catch(() => {
          this.alertMessage.create({
            type: 'error',
            message: this.translate.instant('ce.analise.alertas.requisicaoVideo.errorMsg'),
            appendTo: '.alerta-aqui-requisicao-video'
          });
        });
    }

    requestSnapshot() {
      this.restangular.all('video/snapshots')
        .post({
          uoId: this.alerta.uoId,
          veiculoId: this.alerta.veiculo.id,
          dateTime: this.alerta.datahora,
          type: 'TELEMETRY_EVENT',
          cameras: this.snapshotCameras
        })
        .then(response => {
          this.close({
            $value: {
              snapshotId: response.id
            }
          });
        })
        .catch(() => {
          this.alertMessage.create({
            type: 'error',
            message: this.translate.instant('ce.analise.alertas.requisicaoVideo.errorMsg'),
            appendTo: '.alerta-aqui-requisicao-video'
          });
        });
    }

    sendEventToGTM() {
      this.googleTagManagerUtils.sendEventClickGTM('analise_alertas_solicitar_video', this.serviceVfiltro.factoryVfiltro.user);
    }

    buildSnapshotCameras() {
      for (let i = 0; i < 5; i++) {
        this.snapshotCameras.push({
          indice: i
        });
      }
    }
  }

  angular
    .module('requisicaoVideo')
    .component('modalRequisicaoVideo', {
      controller: ModalRequisicaoVideoCtrl,
      templateUrl: 'historico-alerta/modal-requisicao-video.tpl.html',
      bindings: {
        close: '&',
        dismiss: '&',
        resolve: '<'
      }
    });
}());
